module.exports = __webpack_public_path__ + "img/image10-1.191a1e03.jpeg";